export enum FirebaseAuthError {
	EmailAlreadyInUse = "auth/email-already-in-use",
	InvalidEmail= "auth/invalid-email",
}